import React from "react";
import { FaBuilding, FaUser } from "react-icons/fa";

export function isIndividualParty(party) {
  return party?.Party_Type === "Individual";
}

/** Organization -> building, Individual -> person. */
export function PartyTypeIcon({ type, className = "", size }) {
  const Icon = type === "Individual" ? FaUser : FaBuilding;
  return <Icon className={className} size={size} aria-hidden="true" />;
}

/** Round avatar with the party-type icon, used next to party names. */
export function PartyAvatar({ party, size = "md" }) {
  const individual = isIndividualParty(party);
  return (
    <span
      className={`bill-to-avatar bill-to-avatar--${size} ${individual ? "bill-to-avatar--person" : "bill-to-avatar--org"}`}
      title={individual ? "Individual" : "Organization"}
    >
      <PartyTypeIcon type={party?.Party_Type} />
    </span>
  );
}

/** Pill showing the party type with its icon ("Organization" / "Individual"). */
export function PartyTypeTag({ type, label }) {
  const individual = type === "Individual";
  return (
    <span className={`bill-to-tag bill-to-tag--icon ${individual ? "bill-to-tag--person" : "bill-to-tag--org"}`}>
      <PartyTypeIcon type={type} />
      {label || (individual ? "Individual" : "Organization")}
    </span>
  );
}
